import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "black";
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomColor: "black",
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    fontSize: 9,
    fontWeight: "bold",
    marginTop: 4,
    textAlign: "left",
  },
  rowM: {
    flexDirection: "row",
    borderBottomColor: "black",
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "left",
  },
  description: {
    width: "85%",
    textAlign: "right",
    paddingRight: 8,
    borderRightColor: borderColor,
    borderRightWidth: 1,
    backgroundColor: "#ffffffff",
  },
  total: {
    width: "15%",
    textAlign: "center",
    borderRightWidth: 1,
    backgroundColor: "#ffffffff",
  },
  Realtotal: {
    width: "15%",
    textAlign: "right",
    borderRightWidth: 0,
    backgroundColor: "#ffffffff",
    color: "black",
  },
  RealtotalLabel: {
    width: "85%",
    textAlign: "right",
    paddingRight: 8,
    borderRightColor: borderColor,
    borderRightWidth: 0,
    backgroundColor: "#ffffffff",
    color: "black",
  },
});

const InvoiceTableFooter = ({ invoice, items }) => {
  const total = invoice?.products?.reduce((acc, item) => {
    return acc + parseFloat(item.quantity) * parseFloat(item.customer_price);
  }, 0.0);

  return (
    <>
      <View style={styles.row}>
        <Text style={styles.RealtotalLabel}>SUB TOTAL</Text>
        <Text style={styles.Realtotal}>
          $
          {total.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </Text>
      </View>
      <View style={styles.rowM}>
        <Text style={styles.RealtotalLabel}>SHIPPING</Text>
        <Text style={styles.Realtotal}>${invoice?.shipping_cost}</Text>
      </View>
      <View style={styles.rowM}>
        <Text style={styles.RealtotalLabel}>TOTAL</Text>
        <Text style={styles.Realtotal}>
          $
          {(
            parseFloat(total || 0) + parseFloat(invoice?.shipping_cost || 0)
          ).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </Text>
      </View>
      {/* <View style={styles.rowM}>
        <Text style={styles.RealtotalLabel}>TOTAL</Text>
        <Text style={styles.Realtotal}>
          $
          {(
            parseFloat(total || 0) + parseFloat(invoice?.shipping_cost || 0)
          ).toFixed(2)}
        </Text>
      </View> */}
    </>
  );
};

export default InvoiceTableFooter;
